/* tslint:disable */
/* eslint-disable */
/**
 * Kiwi Framework
 * Kiwi API description
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ClassEnrollResponse
 */
export interface ClassEnrollResponse {
    /**
     * 
     * @type {string}
     * @memberof ClassEnrollResponse
     */
    classId: string;
}

/**
 * Check if a given object implements the ClassEnrollResponse interface.
 */
export function instanceOfClassEnrollResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "classId" in value;

    return isInstance;
}

export function ClassEnrollResponseFromJSON(json: any): ClassEnrollResponse {
    return ClassEnrollResponseFromJSONTyped(json, false);
}

export function ClassEnrollResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClassEnrollResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'classId': json['classId'],
    };
}

export function ClassEnrollResponseToJSON(value?: ClassEnrollResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'classId': value.classId,
    };
}

